import Model from 'core/model/Model';

class SharedLinkModel extends Model {
  get urlRoot() {
    return '/api/ui/shared-links';
  }
}

export default SharedLinkModel;
